import React, { useEffect, useRef, useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Footer from './Footer';
import { labelAllTables } from '../helpers/responsive-tables';
import './Layout.css';

const Layout = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const contentRef = useRef(null);

  // Keep data-label on table cells in sync so tables become labeled cards on mobile.
  useEffect(() => {
    const root = contentRef.current;
    if (!root || typeof MutationObserver === 'undefined') return undefined;
    let frame = 0;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        labelAllTables(root);
      });
    };
    schedule();
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    return () => {
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  useEffect(() => {
    if (!drawerOpen) return undefined;
    const onKey = (e) => e.key === 'Escape' && setDrawerOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [drawerOpen]);

  return (
    <div className={'pz-app' + (drawerOpen ? ' drawer-open' : '')}>
      <Sidebar open={drawerOpen} onNavigate={() => setDrawerOpen(false)} />
      <div
        className={'pz-backdrop' + (drawerOpen ? ' show' : '')}
        onClick={() => setDrawerOpen(false)}
      />
      <div className='pz-main'>
        <Topbar onToggleSidebar={() => setDrawerOpen((o) => !o)} />
        <main className='pz-content' ref={contentRef}>
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
